import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation } from '../../utils/AppFunctions'
import { fetch_all_bulletin } from '../../api/bulletinAPI';
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdEdit } from 'react-icons/md';
import { tidy_date, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function BulletinPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")

  const [bulletin, setBulletinData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchBulletIn()
  }, [])

  const fetchBulletIn = async () => {
    setLoading(true);
    const data = await fetch_all_bulletin();
    if (data?.status === 200) {
      setBulletinData(data.data || []);
    }
    setLoading(false);
  }

  const table_columns = [
    {
      header: "Name",
      accessor: "title"
    },
    {
      header: "Remarks",
      accessor: "remarks",
      modifier: (data) => data || "N/A"
    },
    {
      header: "Items",
      accessor: "announcements",
      modifier: (data) => `${Array.isArray(data) ? data.length : 0} items`
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]

  return (
    <AdminLayout
      navSelected={"Bulletin"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Bulletin</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/bulletin/details?bulletin_id=new")
            }}
          >
            <MdAdd size={16} />
            New Bulletin
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={bulletin}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/bulletin/details?bulletin_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
